/**
 * partner-signup.js (Dawn)
 * - Activa el formulario pegado en Pages (sin <script> inline).
 * - Maneja Step 1 -> Step 2, Back, validaciones y confirmación.
 * - Captura sponsor (?sponsor=...), landing_url y referrer_url en hidden inputs.
 * - Captura UTMs (utm_source, utm_medium, utm_campaign, utm_term, utm_content).
 * - POST a n8n con header X-TRICANAL-SECRET.
 * - Si n8n responde exists/status=exists => muestra alerta y NO pasa a confirmación.
 */;
(function () {
  "use strict";

  // ====== CONFIG ======
  var N8N_WEBHOOK_URL = "https://kamaygroup.app.n8n.cloud/webhook/partner-signup";
  var TRICANAL_SECRET = "B@l@nc360!";
  var EXPECTED_PAGE_HANDLE = "partner-signup";

  // ====== Helpers ======

  function resolveTag(type){
  switch(type){
    case "ambassador": return "AMBASSADOR";
    case "institution": return "INSTITUTION";
    case "sponsor": return "AMBASSADOR_SPONSOR";
    case "distributor": return "DISTRIBUTOR";
    default: return "";
  }
}

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function $(id) { return document.getElementById(id); }

  function getCheckedValue(name) {
    var el = document.querySelector('input[name="' + name + '"]:checked');
    return el ? (el.value || "") : "";
  }


  function setAlert(el, msg, type) {
    if (!el) return;
    el.classList.remove("error", "success");
    el.textContent = msg || "";
    if (!msg) { el.style.display = "none"; return; }
    if (type) el.classList.add(type);
    el.style.display = "block";
  }

  function safeValue(el) { return el ? (el.value || "").trim() : ""; }

  function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }

  function normalizePhone(phone) { return (phone || "").replace(/\s+/g, ""); }

  function isValidWhatsapp(phone) { return /^\+\d{8,15}$/.test(phone); }

  // =====================================================
  // VALIDACION TELEFONO EL SALVADOR (Shopify E.164 estricto)
  // =====================================================
  function normalizeSVPhone(phone) {
    if (!phone) return null;
    var digits = phone.replace(/\D/g, '');
    if (digits.startsWith('503')) digits = digits.substring(3);
    if (digits.length !== 8) return null;
    return '+503' + digits;
  }

  function getPageHandleFromBody() {
    var b = document.body;
    if (!b) return "";
    return b.getAttribute("data-page-handle") || "";
  }

  function disableBtn(btn, label) { if (!btn) return; btn.disabled = true; if (label) btn.textContent = label; }
  function enableBtn(btn, label) { if (!btn) return; btn.disabled = false; if (label) btn.textContent = label; }

  // ====== Core init ======
  function initPartnerSignup() {
    var root = $("partnerSignupRoot");
    if (!root) return;

    var handle = getPageHandleFromBody();
    if (handle && EXPECTED_PAGE_HANDLE && handle !== EXPECTED_PAGE_HANDLE) return;

    var form = $("partnerSignupForm");
    var step1 = $("psStep1");
    var step2 = $("psStep2");
    var confirm = $("psConfirm");

    var badge1 = $("psStepBadge1");
    var badge2 = $("psStepBadge2");

    var btnNext = $("psBtnNext");
    var btnBack = $("psBtnBack");
    var btnSubmit = $("psBtnSubmit");

    var alert1 = $("psAlert1");
    var alert2 = $("psAlert2");

    if (!form || !step1 || !step2 || !badge1 || !badge2 || !btnNext || !btnBack || !btnSubmit) {
      console.warn("[partner-signup] Falta algún elemento clave. Revisa que el HTML pegado en Pages esté completo.");
      return;
    }

    function goToStep(n) {
      step1.style.display = (n === 1) ? "block" : "none";
      step2.style.display = (n === 2) ? "block" : "none";
      if (confirm) confirm.style.display = "none";

      badge1.classList.toggle("active", n === 1);
      badge2.classList.toggle("active", n === 2);

      setAlert(alert1, "", "");
      setAlert(alert2, "", "");

      window.scrollTo({ top: root.offsetTop - 10, behavior: "smooth" });
    }

    function validateStep1() {
      var typeChecked = document.querySelector('input[name="partner_type"]:checked');
      var brand = safeValue($("brand"));
      var country = safeValue($("country"));
      var city = safeValue($("city"));

      if (!typeChecked) return "Selecciona cómo te gustaría colaborar (tipo de partner).";
      if (!brand) return "Selecciona la marca que deseas promover.";
      if (!country) return "Selecciona tu país.";
      if (!city) return "Ingresa tu ciudad.";
      return "";
    }

    function validateStep2() {
      var legalName = safeValue($("legal_name"));
      var contactName = safeValue($("contact_name"));
      var email = safeValue($("email"));
      var whatsapp = normalizeSVPhone(safeValue($("whatsapp")));
      var consent = $("consent") ? $("consent").checked : false;

      if (!legalName) return "Ingresa tu nombre completo o razón social.";
      if (!contactName) return "Ingresa el nombre de contacto.";
      if (!email || !isValidEmail(email)) return "Ingresa un email válido.";
      if (!whatsapp) return "El WhatsApp debe tener 8 dígitos válidos de El Salvador (ej. +50370000000).";
      if (!consent) return "Debes aceptar la confirmación para enviar la solicitud.";
      return "";
    }

    var qs = new URLSearchParams(window.location.search);
    var sponsor = qs.get("sponsor") || "";

    var utm_source   = qs.get("utm_source") || "";
    var utm_medium   = qs.get("utm_medium") || "";
    var utm_campaign = qs.get("utm_campaign") || "";
    var utm_term     = qs.get("utm_term") || "";
    var utm_content  = qs.get("utm_content") || "";

    var sponsorEl = $("sponsor");
    var landingEl = $("landing_url");
    var refEl = $("referrer_url");

    if (sponsorEl) sponsorEl.value = sponsor;
    if (landingEl) landingEl.value = window.location.href;
    if (refEl) refEl.value = document.referrer || "";

    btnNext.addEventListener("click", function () {
      var err = validateStep1();
      if (err) { setAlert(alert1, err, "error"); return; }
      goToStep(2);
    });

    btnBack.addEventListener("click", function () { goToStep(1); });

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var err = validateStep2();
      if (err) { setAlert(alert2, err, "error"); return; }

      var typeChecked = document.querySelector('input[name="partner_type"]:checked');
      var contactChecked = document.querySelector('input[name="preferred_contact_channel"]:checked');

      var tag = resolveTag(typeChecked ? typeChecked.value : "");
      var tagEl = document.getElementById("partnerTag");
      if(tagEl) tagEl.value = tag;


      var payload = {
        partner_type: typeChecked ? typeChecked.value : "",
        brand: safeValue($("brand")),
        legal_name: safeValue($("legal_name")),
        contact_name: safeValue($("contact_name")),
        email: safeValue($("email")),
        whatsapp: normalizeSVPhone(safeValue($("whatsapp"))),
        PreferredContactChannel: contactChecked ? contactChecked.value : "",
        country: safeValue($("country")),
        city: safeValue($("city")),
        social_or_site: safeValue($("social_or_site")),
        socialOrSite: safeValue($("social_or_site")),
        sponsor: sponsorEl ? (sponsorEl.value || "") : sponsor,
        sponsorAffiliateId: sponsorEl ? (sponsorEl.value || "") : sponsor,
        landing_url: landingEl ? (landingEl.value || window.location.href) : window.location.href,
        referrer_url: refEl ? (refEl.value || (document.referrer || "")) : (document.referrer || ""),
        consent: $("consent") ? $("consent").checked : false,
        TAG: typeChecked ? typeChecked.value : "",
        utm_source: utm_source,
        utm_medium: utm_medium,
        utm_campaign: utm_campaign,
        utm_term: utm_term,
        utm_content: utm_content,

        BrandId: safeValue($("brand")),
        LegalName: safeValue($("legal_name")),
        ContactName: safeValue($("contact_name")),
        PartnerType: typeChecked ? typeChecked.value : ""
      };

      payload.note_attributes = [
        { name: "partner.affiliate_id",        value: "" },
        { name: "partner.type",                value: payload.partner_type || "" },
        { name: "partner.brand",               value: payload.brand || "" },
        { name: "partner.parent_affiliate_id", value: payload.sponsor ? payload.sponsor : "" },
        { name: "partner.status",              value: "APPLIED" },
        { name: "partner.whatsapp",            value: payload.whatsapp || "" },
        { name: "partner.preferred_contact_channel", value: payload.PreferredContactChannel || "" },
        { name: "partner.country",             value: payload.country || "" },
        { name: "partner.city",                value: payload.city || "" },
        { name: "partner.sponsor",             value: payload.sponsor || "" },
        { name: "partner.tag",                 value: payload.partner_type || "" },

      ];

      if (!N8N_WEBHOOK_URL) {
        step1.style.display = "none";
        step2.style.display = "none";
        if (confirm) confirm.style.display = "block";
        window.scrollTo({ top: root.offsetTop - 10, behavior: "smooth" });
        return;
      }

      disableBtn(btnSubmit, "✅ Creando tu cuenta…");
      setAlert(alert2, "Enviando tu solicitud… ⏳ Espera un momento, estamos creando tu cuenta.", "");

      fetch(N8N_WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-TRICANAL-SECRET": TRICANAL_SECRET
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            var result = Array.isArray(data) ? data[0] : data;

            if (result && (result.exists === true || result.status === "exists")) {
              var existsMsgRaw = result && result.message ? result.message : "Ya existe un registro con ese email o WhatsApp.";
              var existsMsg = (function(m){
                if (m == null) return "";
                if (typeof m === "string") return m;
                if (typeof m === "object") {
                  if (m.message) return String(m.message);
                  if (m.error) return String(m.error);
                  try { return JSON.stringify(m); } catch(e) { return String(m); }
                }
                return String(m);
              })(existsMsgRaw);
              throw new Error(existsMsg);
            }

            if (!res.ok || (result && result.ok === false)) {
              var msgRaw = (result && (result.message_es || result.message)) ? (result.message_es || result.message) : "No se pudo enviar la solicitud. Intenta nuevamente.";
              var msg = (function(m){
                if (m == null) return "";
                if (typeof m === "string") return m;
                if (typeof m === "object") {
                  if (m.message) return String(m.message);
                  if (m.error) return String(m.error);
                  try { return JSON.stringify(m); } catch(e) { return String(m); }
                }
                return String(m);
              })(msgRaw);
              throw new Error(msg);
            }
            return data;
          });})
        .then(function (data) {
          var result = Array.isArray(data) ? data[0] : data;

          if (result && (result.DiscountCode || result.ShareLink || result.AffiliateId)) {
            var msg = "¡Solicitud enviada con éxito!";
            if (result.AffiliateId) msg += " Partner: " + result.AffiliateId;
            if (result.DiscountCode) msg += " Código: " + result.DiscountCode;
            setAlert(alert2, msg, "success");

            var affiliateEl = document.getElementById("psAffiliateId");
            var codeEl = document.getElementById("psDiscountCode");
            var linkEl = document.getElementById("psShareLink");
            var shortLinkEl = document.getElementById("psShortLink");
            var qrWrapEl = document.getElementById("psQrWrapper");
            var qrImgEl = document.getElementById("psQrImage");

            if (affiliateEl && result.AffiliateId) affiliateEl.textContent = result.AffiliateId;
            if (codeEl && result.DiscountCode) codeEl.textContent = result.DiscountCode;
            if (linkEl && result.ShareLink) { linkEl.href = result.ShareLink; linkEl.textContent = result.ShareLink; }
            if (shortLinkEl && result.ShortLink) { shortLinkEl.href = result.ShortLink; shortLinkEl.textContent = result.ShortLink; }
                        // ===== Institution links (solo si partner_type = institution, case-insensitive) =====
            var institutionWrapEl = document.getElementById("psInstitutionLinks");
            var shareInstitutionEl = document.getElementById("psShareInstitutionLink");
            var shortInstitutionEl = document.getElementById("psShortInstitutionLink");

            var pt = (typeChecked && typeChecked.value) ? String(typeChecked.value).toLowerCase() : "";

            if (pt === "institution") {
              if (institutionWrapEl) institutionWrapEl.style.display = "block";

              if (shareInstitutionEl && result.ShareInstitutionLink) {
                shareInstitutionEl.href = result.ShareInstitutionLink;
                shareInstitutionEl.textContent = result.ShareInstitutionLink;
              }

              if (shortInstitutionEl && result.ShortInstitutionLink) {
                shortInstitutionEl.href = result.ShortInstitutionLink;
                shortInstitutionEl.textContent = result.ShortInstitutionLink;
              }
            } else {
              if (institutionWrapEl) institutionWrapEl.style.display = "none";
            }
            // =================================================================

            if (qrImgEl && qrWrapEl && result.QrCodeUrl) {
              qrImgEl.src = result.QrCodeUrl;
              qrImgEl.alt = "QR " + (result.AffiliateId || "");
              qrWrapEl.style.display = "block";
            }
          } else { setAlert(alert2, "", ""); }

          step1.style.display = "none";
          step2.style.display = "none";
          if (confirm) confirm.style.display = "block";
          window.scrollTo({ top: root.offsetTop - 10, behavior: "smooth" });
        })
        .catch(function (ex) {
          setAlert(alert2, ex && ex.message ? ex.message : "Error inesperado. Intenta nuevamente.", "error");
        })
        .finally(function () { enableBtn(btnSubmit, "Enviar solicitud"); });
    });

    goToStep(1);
  }

  onReady(initPartnerSignup);
})();
